module.exports = __webpack_public_path__ + "static/media/featured-product.62930fcb.png";